/**
 * Use constants for exchangeNames
 * Supported exchanges:
 */
export const BINANCE = 'binance';
export const HUOBI = 'huobi';
export const BITTREX = 'bittrex';
export const HITBTC = 'hitbtc';
export const UNISWAP = 'uniswap';
export const PANCAKE = 'pancakeswap';
export const SUSHISWAP = 'sushiswap';
export const GATEIO = 'gateio';
export const QUICKSWAP = 'quickswap';
export const IMPOSSIBLE = 'impossibleswap';
export const MAIAR = 'maiar';
export const TRADERJOE = 'traderjoe';
export const VOLTSWAP = 'voltswap';
export const SPIRITSWAP = 'spiritswap';
export const SPOOKYSWAP = 'spookyswap';
export const PANGOLIN = 'pangolin';
export const CRYPTOCOM = 'cryptocom';
export const KUCOIN = 'kucoin';
export const SUNSWAP = 'sunswap';
export const JUSTMONEY = 'justmoney';
export const KYBER = 'kyber';
export const BISWAP = 'biswap';
export const MDEX = 'mdex';
export const OKXDEX = 'okxdex';
export const CHERRYSWAP = 'cherryswap';

/**
  * Once these exchanges were supported
  * Not-supported exchanges:
  */
export const PAPER = 'paper';
export const POLONIEX= 'poloniex';
export const BITFINEX = 'bitfinex';
export const KRAKEN = 'kraken';
export const OKEX = 'okex';


export const EXCHANGES_LIST = [
  BINANCE,
  HUOBI,
  // BITTREX,
  HITBTC,
  // 'okex',
  UNISWAP,
  SUSHISWAP,
  PANCAKE,
  GATEIO,
  QUICKSWAP,
  MDEX,
  BISWAP,
  SPOOKYSWAP,
  IMPOSSIBLE,
  MAIAR,
  TRADERJOE,
  PANGOLIN,
  KUCOIN,
  SUNSWAP,
  JUSTMONEY,
  KYBER,
  OKXDEX,
  CHERRYSWAP
];

export const DEX_LIST = [
  UNISWAP,
  PANCAKE,
  SUSHISWAP,
  QUICKSWAP,
  MDEX,
  SPOOKYSWAP,
  IMPOSSIBLE,
  BISWAP,
  MAIAR,
  TRADERJOE,
  PANGOLIN,
  SUNSWAP,
  JUSTMONEY,
  KYBER,
  OKXDEX,
  CHERRYSWAP
];

export const CEX_LIST = [
  BINANCE,
  HITBTC,
  HUOBI,
  GATEIO,
  KUCOIN,
];

export const ETH_EXCHANGES = [
  UNISWAP,
  SUSHISWAP,
  CRYPTOCOM,
];

export const BSC_EXCHANGES = [PANCAKE, IMPOSSIBLE, BISWAP, MDEX];
export const METER_EXCHANGES = [VOLTSWAP];
export const MATIC_EXCHANGES = [QUICKSWAP];
export const HECO_EXCHANGES = [MDEX];
export const AVAX_EXCHANGES = [TRADERJOE, PANGOLIN];
export const ELROND_EXCHANGES = [MAIAR];
export const FANTOM_EXCHANGES = [SPIRITSWAP, SPOOKYSWAP];
export const BTTC_EXCHANGES: string[] = [KYBER];
export const TRON_EXCHANGES = [SUNSWAP, JUSTMONEY];
export const OKX_EXCHANGES = [OKXDEX, CHERRYSWAP];
